import { Button, Callout, Intent } from "@blueprintjs/core"
import { useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router"
import { __ } from "src/libs/utilities"
import { ITestsStore, useTestsStore } from "../../data/store"
import { ITestProps } from "./SingleTest"
import StepsMonitor from "./StepsMonitor"
import TestTimer from "./TestTimer" 

const Test = ({ item }: ITestProps) : JSX.Element => {
  const navigate = useNavigate() 
  const waybill: string[] = useTestsStore((state:ITestsStore) => state.waybill)
  const currentStepValue: any = useTestsStore((state:ITestsStore) => state.currentStepValue)
  const currentStep: number = useTestsStore((state:ITestsStore) => state.currentStep || 0)
  const tryCount: number = useTestsStore((state:ITestsStore) => state.tryCount) 
  useEffect(() => { 
    
  }, [ item ])

  useEffect(() => {
    // console.table({ navigate: waybill[ currentStep ], currentStep, waybill })
    navigate( waybill[ currentStep ] )
    if( currentStep === 0 ) {
      useTestsStore.setState( { results : [] } ) 
    }
  }, [ currentStep ])

  const onPrev = () => {
    const next = currentStep === 0 ?  waybill.length - 1 : currentStep - 1
    navigate( waybill[ next ] )
    useTestsStore.setState( { currentStep : next } ) 
  }

  const isNextDisabled = () => {
    return currentStep !== 0 && currentStep !== waybill.length - 1 && !currentStepValue
  }
  const onNextClick = () => { 
    if( !isNextDisabled()) {
      onNext()
    }
    
  }
  const onNext = () => {
    const isFinish: boolean = currentStep === waybill.length - 1
    const next = isFinish ? 0 : currentStep + 1
    useTestsStore.setState( { currentStep : next, currentStepValue: null } ) 
    if(isFinish) {
      useTestsStore.setState( { tryCount : tryCount + 1 } ) 
    }
  }
  const isTimed: boolean = !!item.is_timed && currentStep > 0 && currentStep <= item.questions.length
  return (
    <div className="w-100 layout-app-state  d-flex flex-column position-relative " data-testid="test-cont">
        <StepsMonitor item={ item } current={ currentStep } full={ item.questions.length + 1 }/>
        <div className="flex-grow-100  d-flex flex-column overflow-y-auto">
          <Outlet />
        </div>
        <div className="flex-centered px-0 mb-5 pb-4 pe-test-next-button-cont">
          {
            item.try_count >= tryCount && !isTimed
              ?
              <>
                <Button 
                  disabled={ isNextDisabled() } 
                  size="large" 
                  variant={ isNextDisabled() ? "minimal" : "outlined" }  
                  onClick={ onNextClick } 
                  className={ isNextDisabled() ? "opacity_5" : "" } 
                  data-testid="test-next-button"
                >
                  { __( getLabel( currentStep, item.questions.length + 1 ) ) }
                </Button>
                {/* { currentStep !== 0 && <Button large minimal onClick={onPrev} icon="caret-left" /> } */}
              </>
              :
              isTimed
                ?
                <TestTimer onBreak={ onNext } duration={item.duration || 0}/>
                :
                <div className="short-container" data-testid="test-callout">
                  <Callout
                    intent={Intent.DANGER}
                    className="p-5 text-center mt-4"
                  >
                    {__("All your attempts to pass the test are exhausted")}
                  </Callout>
                </div>
          } 
        </div> 
    </div>
  )
}

export default Test

const getLabel = (current: number, full: number): string => {
  switch( current ) {
    case 0:
      return "Start"
    case full:
      return "Replay"
    case 1:
    default:
      return __("Next ") + ( full >= current + 1 ? (current + 1 ) + __(" from ") + full : "")
  }
}